import { render, staticRenderFns } from "./ip-blacklisted.vue?vue&type=template&id=51176741&"
import script from "./ip-blacklisted.vue?vue&type=script&lang=ts&"
export * from "./ip-blacklisted.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports